<div
  class="quill-editor-container"
  [class.editor-invalid]="isTouched && isInvalid"
  [class.editor-disabled]="isDisabled"
>
  <quill-editor
    class="quill-editor"
    [modules]="editorModules"
    (onEditorCreated)="onEditorCreated($event)"
    [attr.id]="id"
    [attr.name]="name"
    bounds=".quill-editor-container"
  >
  </quill-editor>
</div>
